import * as React from "react";
import {translate} from "react-i18next";

import {
    RoleDto,
    UserDto,
    GroupDto,
    AssignedUserRoleDto,
    AssignedGroupRoleDto,
} from "../../../services/Client";

import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";
import RoleSelection from "./RoleSelection";
import {
    createAssignedUserRoles,
    createAssignedGroupRoles,
    extractRoles,
} from "../AdminUtils";

export enum RoleAssignmentType {
    USER = "user",
    GROUP = "group",
}

interface IAssignedRoleSelectionProps extends ITranslatedComponent {
    /** All available roles. */
    roles: RoleDto[];

    /** type of role assignment */
    roleAssignType: RoleAssignmentType;

    /** The parent DTO of the AssignedRoles. */
    parentDto: UserDto | GroupDto;

    /** Initially selected assigned roles. */
    values?: AssignedUserRoleDto[] | AssignedGroupRoleDto[];

    /** Callback when the selected roles change. */
    onChange: (assignedRoles: AssignedUserRoleDto[] | AssignedGroupRoleDto[]) => any;
}

interface IAssignedRoleSelectionState {
}

/**
 * A React component for selection of assigned roles for users and groups.
 * It can be used to change the assigned roles of existing users/groups or
 * during creation of a new user/group.
 * By default the component displays a RoleSelection control.
 */
class AssignedRoleSelection extends React.Component<IAssignedRoleSelectionProps, IAssignedRoleSelectionState> {
    constructor(props: IAssignedRoleSelectionProps) {
        super(props);

        this.state = {};
    }

    onRoleSelectionChanged = (roles: RoleDto[]): void => {
        let assignedRoles: AssignedUserRoleDto[] | AssignedGroupRoleDto[] = [];
        switch (this.props.roleAssignType) {
            case RoleAssignmentType.USER:
                assignedRoles = createAssignedUserRoles(roles, this.props.parentDto as UserDto);
                break;
            case RoleAssignmentType.GROUP:
                assignedRoles = createAssignedGroupRoles(roles, this.props.parentDto as GroupDto);
                break;
            default:
                throw new Error("Invalid parent DTO type");
        }

        this.props.onChange(assignedRoles);
    }

    render() {
        return (
            <>
                <RoleSelection
                    placeholder={this.props.t("SELECT_ROLES")}
                    roles={this.props.roles}
                    values={extractRoles(this.props.values || [])}
                    onChange={this.onRoleSelectionChanged}
                />
            </>
        );
    }
}

export default translate("ADMIN_VIEW")(AssignedRoleSelection);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/AssignedRoleSelection.tsx